import {ImageStateRecord, COLUMNS} from './ImageStateRecord';
import {IMAGES_LOADED, PAGE_RESIZED} from './actions';

const DEFAULT_STATE = new ImageStateRecord();

export function imageStateReducer(state = DEFAULT_STATE, {type, payload} = {}) {
  switch (type) {

    case IMAGES_LOADED: {
      return payload.reduce((imageState, image) => (
        imageState
          .setIn(['images', String(image.id)], image)
          .set('oneColumn', imageState.oneColumn.addImage(image))
          .set('twoColumn', imageState.twoColumn.addImage(image))
          .set('threeColumn', imageState.threeColumn.addImage(image))
      ), state);
    }

    case PAGE_RESIZED: {
      if (payload > 799) {
        return state.set('noOfColumns', COLUMNS.THREE);
      }

      if (payload > 450) {
        return state.set('noOfColumns', COLUMNS.TWO);
      }

      return state.set('noOfColumns', COLUMNS.ONE);
    }

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/state/images/imageStateReducer.js